import { render, staticRenderFns } from "./NoticeDetailModal.vue?vue&type=template&id=18b0597c&scoped=true"
import script from "./NoticeDetailModal.vue?vue&type=script&lang=js"
export * from "./NoticeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetailModal.vue?vue&type=style&index=0&id=18b0597c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0597c",
  null
  
)

export default component.exports